import React, { Fragment, useMemo, VFC } from 'react';
import { JourneyMenu, JourneyMenuPropsInterface } from 'src/common/JourneyMenu';
import { useReactConstructor } from 'src/utils/react/constructor.hook';
import { DeleteRegularIcon, EditRegularIcon, FrameImageRegularIcon } from 'src/monet/icons';

export interface DashboardLibrarySyncedStepsOptionsMenuProps
  extends Pick<JourneyMenuPropsInterface, 'openRef' | 'closeRef' | 'renderOrigin' | 'offset' | 'placement'> {
  onOpen: () => void;
  onClose: () => void;
  onEdit: () => void;
  onDelete: () => void;
  onRefreshThumbnail: () => void;
}

const menuItemClasses = 'text-bedrock-p text-bedrock-black flex items-center space-x-sm';

export const DashboardLibrarySyncedStepsOptionsMenu: VFC<DashboardLibrarySyncedStepsOptionsMenuProps> = ({
  openRef,
  closeRef,
  onOpen,
  offset,
  placement,
  onClose,
  renderOrigin,
  onEdit,
  onDelete,
  onRefreshThumbnail,
}) => {
  useReactConstructor(() => {
    return () => {
      onClose();
    };
  });

  const menuOptions = useMemo(
    () => [
      <JourneyMenu.Item className={menuItemClasses} onClick={onEdit}>
        <EditRegularIcon />
        <span>Edit</span>
      </JourneyMenu.Item>,
      <JourneyMenu.Item className={menuItemClasses} onClick={onDelete}>
        <DeleteRegularIcon />
        <span>Delete</span>
      </JourneyMenu.Item>,
      <JourneyMenu.Item className={menuItemClasses} onClick={onRefreshThumbnail}>
        <FrameImageRegularIcon />
        <span>Refresh thumbnail</span>
      </JourneyMenu.Item>,
    ],
    [onEdit, onDelete, onRefreshThumbnail]
  );

  return (
    <JourneyMenu
      placement={placement}
      offset={offset}
      openRef={openRef}
      closeRef={closeRef}
      onOpen={onOpen}
      onClose={onClose}
      renderOrigin={renderOrigin}
    >
      {menuOptions.map((option, index) => (
        <Fragment key={`menu-item-${index}`}>{option}</Fragment>
      ))}
    </JourneyMenu>
  );
};
